import { render, staticRenderFns } from "./SeoDetails.vue?vue&type=template&id=393295ba&"
import script from "./SeoDetails.vue?vue&type=script&lang=js&"
export * from "./SeoDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports